module.exports = __webpack_public_path__ + "img/home_title_m_w.35f2aceb.png";